import axios from "axios";

const BASE = process.env.REACT_APP_BASE_URL;
export const WEB_IMAGE_BASE = "https://speakboldwithkk.com";

export const fetchWebImagesByCategory = async (category) => {
  try {
    const res = await axios.get(`${BASE}/public/web-images/category/${category}`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: [] };
  }
};

export const fetchAllPublicWebImages = async () => {
  try {
    const res = await axios.get(`${BASE}/public/web-images`);
    return { status: res.status, data: res.data };
  } catch (err) {
    return { status: err.response?.status || 500, data: [] };
  }
};
